import { render, staticRenderFns } from "./analysis.vue?vue&type=template&id=0c21951d&scoped=true&"
import script from "./analysis.vue?vue&type=script&lang=js&"
export * from "./analysis.vue?vue&type=script&lang=js&"
import style1 from "./analysis.vue?vue&type=style&index=1&id=0c21951d&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c21951d",
  null
  
)

export default component.exports